export const DATETIME_FORMATS = ['MMMM Do YYYY, h:mm:ss a', 'MMM Do YY', 'dddd', 'MMM', 'MMMM', 'YYYY'];
export const DATE_FORMATS = ['MMMM Do YYYY', 'MMM Do YY', 'dddd', 'Do', 'MMM', 'MMMM', 'YYYY'];
export const TIME_FORMATS = ['h:mm:ss a', 'h:mm:ss', 'h:mm', 'h', 'mm:ss', 'mm', 'mm:ss a', 'ss a', 'a'];
